import * as React from 'react';

export function withProps<P1, P2 = {}>(Component: React.ComponentType<P1 & P2>, props1: P1) {
  return (props2: P2) => <Component {...props1} {...props2} />;
}

export function unreachable(x: never): never {
  throw new Error('bug');
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/utils/compose.tsx